import React, {Component} from "react";
import CommToolContext from "../../common/comm_tool_context";
import {Grid, Row, Col} from "react-flexbox-grid";
import InDevTabs from "./indevelop_tabs";
import {getProject, getProjectsHazardous} from '../../../api';

class IndevelopProject extends Component {

    constructor(props) {
        super(props);

        this.state = {
            projectId: props.match.params.projectId,
            bpid: props.match.params.bpid, 
            project: null,
            projectHazard : null,
            loading: true,

        }
    }

    async componentDidMount() {        
        this.setState({loading:true})
        try{
            const project = await getProject(this.state.projectId);
            const projectHazard = await getProjectsHazardous(this.state.projectId, project.bpid);
            
            this.setState({project:project,
                projectHazard:projectHazard.hazardousOptions,
                loading:false,
            })

        }catch(error){
            console.error('Error fetching data: ', error);
            this.setState({loading:false, error:error});
        }
    }

    render() {
        const {project, projectHazard, loading, error} = this.state;
        return (
            <CommToolContext.Consumer>
                {context => (
                    <React.Fragment>
                        <Grid fluid>
                            <Row>
                                <Col xs>
                                    {project && <InDevTabs project={project} context={context} status={'development'} hazardousMaterialsSelected={projectHazard}/>}
                                </Col>
                            </Row>
                        </Grid>
                    </React.Fragment>
                )}
            </CommToolContext.Consumer>
        );
    }
}

IndevelopProject.contextType = CommToolContext;
export default IndevelopProject;
